import styled from '@emotion/styled';
import { shouldForwardProps } from '../utils';
import { TextButton } from '../components/buttons/text-button/TextButton';

export const BackButton = styled(TextButton, shouldForwardProps)`
    align-self: flex-start;
    margin-top: ${({ theme }) => theme.spacing(5)};
`;
